<template>
    <page-title
        title="アプリ発注（学校選択）"
    >
        <a href="/guide/general-distributor-order.pdf" class="btn btn-outline-secondary" target="_blank"><i class="bi bi-file-pdf"></i> 発注マニュアル</a>
    </page-title>

    <form class="d-flex flex-wrap gap-2 align-items-end mb-3" @submit.prevent="search()">
        <div class="col-14 col-md-6">
            <label class="form-label">学校名</label>
            <input v-model="condition.school_keyword" type="text" class="form-control">
        </div>
        <div class="col-11 col-md-5">
            <label class="form-label">都道府県</label>
            <form-select
                v-model="condition.pref"
                :options="prefs"
                empty_option="-- 選択 --"
            />
        </div>
        <div class="col-12 col-md-8">
            <label class="form-label">住所</label>
            <input v-model="condition.address" type="text" class="form-control">
        </div>
        <div class="col text-end">
            <button-search type="submit" />
        </div>
    </form>

    <inline-loader v-if="loading"></inline-loader>

    <div v-else>
        <template v-if="schools.length">
            <table-normal class="mb-md-5">
                <thead>
                    <tr>
                        <th>学校名</th>
                        <th>住所</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="school in schools" :key="school.school_id">
                        <td class="text-center">{{ school.school_name }}</td>
                        <td class="text-center">{{ school.full_address }}</td>
                        <td class="text-center">
                            <button-go-view :linkTo="{ name: 'PageSchoolOrder', params: {school_id: school.school_id} }" text="アプリ発注へ" />
                        </td>
                    </tr>
                </tbody>
            </table-normal>
            <paginator :meta="paginator_meta" @move="search"></paginator>
        </template>

        <alert-no-record class="mt-5" v-else></alert-no-record>

    </div>

</template>

<script>
import School from '@/shared/models/entities/school';
import Pref from '@/shared/models/enums/pref';
import InlineLoader from '@/shared/components/tool/InlineLoader';
import Paginator from '@/shared/components/tool/Paginator';
import TableNormal from '@/shared/components/design/TableNormal.vue';
import ButtonSearch from '@/shared/components/design/buttons/ButtonSearch';
import ButtonGoView from '@/shared/components/design/buttons/ButtonGoView.vue';
import PageTitle from '@/shared/components/design/PageTitle.vue';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord.vue';
import FormSelect from '@/shared/components/form/FormSelect.vue';

export default {
    name: 'PageSchoolList',
    components: {
        InlineLoader,
        Paginator,
        TableNormal,
        ButtonSearch,
        ButtonGoView,
        PageTitle,
        AlertNoRecord,
        FormSelect,
    },
    data() {
        return {
            //部分ローダー
            loading: true,

            //選択肢
            prefs: Pref.options(),

            //送信データ(検索用)
            condition: {
                school_keyword: null,
                pref: null,
                address: null,
                page: 1,
            },

            //表示データ
            schools: [],

            //ページネーションデータ
            paginator_meta: {}
        }
    },
    mounted() {
        //storeに前回の検索条件があれば
        this.condition = this.$store.getters['distributor/condition/merge']('PageSchoolList', this.condition);
        //検索
        this.search();
    },
    methods: {
        search(page = 1) {
            this.condition.page = page;
            this.schools = [];
            this.loading = true;
            this.$http.get('/distributor/school', {
                params: this.condition
            })
            .then(response => {
                this.schools = [];
                for (let row of response.data.data) {
                    this.schools.push(new School(row));
                }
                //ページネーション用
                this.paginator_meta = response.data.meta;
                //検索条件を保存
                this.$store.commit('distributor/condition/setSearchCondition', {
                    page: 'PageSchoolList',
                    condition: this.condition
                });
            })
            .finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>
